<template>
    <div class="pagination">
        <button :disabled="pageNo==1" @click="$emit('getPageNo',pageNo-1)">上一页</button>
        <button v-if="startNumAndEndNum.start > 1" @click="$emit('getPageNo',1)" :class="{active:pageNo==1}">1</button>
        <button v-if="startNumAndEndNum.start > 2">···</button> 

        <!-- 中间部分 -->
        <button v-for="(page,index) in startNumAndEndNum.end" :key="index" v-if="page >= startNumAndEndNum.start"  @click="$emit('getPageNo',page)" :class="{active:pageNo==page}">{{page}}</button>


        <button v-if="startNumAndEndNum.end  < totalPage -1">···</button>
        <button v-if="startNumAndEndNum.end < totalPage" @click="$emit('getPageNo',totalPage)" :class="{active:pageNo==total}">{{totalPage}}</button>
        <button @click="$emit('getPageNo',pageNo+1)" :disabled="pageNo==totalPage" >下一页</button>
        <button style="margin-left: 0rem">共 {{total}} 条</button>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        props:['pageNo','pageSize','total','continues'],
        //计算属性
        computed:{
          //总共有多少页
          totalPage(){
                   // 向上取整
            return Math.ceil(this.total/this.pageSize);
          },
          //计算连续的页码：起始数字 和 结束数字
          startNumAndEndNum(){
            const {continues,pageNo,totalPage} = this;
            //定义起始数字 和 结束数字
            let start = 0, end = 0;
            //【不正常现象】总页码数 < 连续页码
            if(continues > totalPage){
                start = 1;
                end = totalPage;
            }else{
              //【正常现象】总页码数 >= 连续页码
              start = pageNo - parseInt(continues/2)
              end = pageNo + parseInt(continues/2)
              //start 出现不正常现象【start < 1】
              if(start < 1){
                start = 1;
                end = continues;
              }
              //end 出现不正常现象【end > totalPage】
              if(end > totalPage){
                start = totalPage - continues + 1;
                end = totalPage;
              }
            }
            return {start,end};
          }
        }
    }
</script>

<style lang="less" scoped>
    .pagination {
      display: flex;
        button {
            margin: 0 0.05rem;
            background: #fff;
            color: #606266;
            outline: none;
            border-radius: 0.02rem;
            padding: 0 0.04rem;
            vertical-align: top;
            display: inline-block;
            font-size: 0.21rem;
            height: 0.48rem;
            min-width: 0.48rem;
            line-height: 0.48rem;
            cursor: pointer;
            box-sizing: border-box;
            text-align: center;
            border: 0;
            border:0.02rem solid #d9d9d9;

            &[disabled] {
                color: #c0c4cc;
                cursor: not-allowed;
                border:0.02rem solid #d9d9d9;
            }

            &.active {
                cursor: not-allowed;
                border:0.02rem solid #409eff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue